import { downloadFile } from '@/utils/http/http.service';
import Http from '@/utils/http/index';

export default {
  /**
   * 出款单列表
   */
  getList(params) {
    return Http.get('/payoutMerchant/list', { params });
  },

  /**
   * 出款单列表导出
   */
  exportDisbursement(params) {
    return Http.get('/payoutMerchant/download', { params });
  },

  /**
   * 出款单列表导出（新API）
   */
  downloadDisbursement(params) {
    return Http.get('/merchant/settlement/payoutDownload', { params });
  },
};
